import { API_ADMIN_URL } from "../../../config/constants";
import { postRequest } from "../../API";


/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditdata = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Ali
* Date          : 11-12-2024 
*********************************************************/
export const imageList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}clipt-art/image-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Ali
* Date          : 11-12-2024 
*********************************************************/
export const AddImage = async (options) =>{

    try {
        const params = {
            url : `${API_ADMIN_URL}clipt-art/add-image`,
            postData : options
        }

        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : list of variantts
* Description   : change service status
* By            : Md Ali
* Date          : 11-12-2024 
*********************************************************/
export const VariantList = async (options) =>{

    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/list`,
            postData : options
        }

        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count || 1};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeVariantStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : deleteVariant
* Description   : delete variant
* By            : Afsar Ali
* Date          : 15-01-2025
*********************************************************/
export const deleteVariant = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Ali
* Date          : 11-12-2024 
*********************************************************/
export const addeditVariantdata = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : updateVariantStock
* Description   : Update Variant Stock
* By            : Afsar Ali
* Date          : 15-01-2025
*********************************************************/
export const updateVariantStock = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/add-stock`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const inventoryList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Functio


/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Ali
* Date          : 11-12-2024 
*********************************************************/
export const addEditInventoryData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/addData`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteInventoryData
* Description   : change service status
* By            : Afsar Ali
* Date          : 15-01-20245
*********************************************************/
export const deleteInventoryData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : updateInventoryData
* Description   : change service status
* By            : Afsar Ali
* Date          : 15-01-20245
*********************************************************/
export const updateInventoryData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/update-stock`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : userInventoryList
* Description   : change service status
* By            : Afsar Ali
* Date          : 16-01-20245
*********************************************************/
export const userInventoryList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/users`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const Orderlist = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/order/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 27-02-2025
*********************************************************/
export const cancelOrder = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/order/cancel`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : changeDeliveryStatus
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 27-02-2025
*********************************************************/
export const changeDeliveryStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/order/delivery-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : addUpdateBulkInventory
* Description   : Add bulk inventory
* By            : Afsar Ali
* Date          : 29-01-2025
*********************************************************/
export const addUpdateBulkInventory = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/bulk-add`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : inventoryLogs
* Description   : Inventory Logs
* By            : Afsar Ali
* Date          : 31-01-2025
*********************************************************/
export const inventoryLogs = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/inventory/log`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : variantLogs
* Description   : Variant Logs
* By            : Sumit Bedwal
* Date          : 04-02-2026
*********************************************************/
export const variantLogs = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}products/variants/log`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function